/**
 * @generated SignedSource<<bee969c8337c7f8adb3f0ebac84e821a>>
 * @relayHash a93c3be21ef84b8f1ece98be06dc6ac9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskModalRendererQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskModalRendererQuery$variables = {
  articleId: string;
  categoryId?: string | null;
  contactSupportSearchQuery?: string | null;
  hasArticleId: boolean;
  hasContactSupportSearchQuery: boolean;
  hasItemId: boolean;
  hasOrderId: boolean;
  hasSearchQuery: boolean;
  hasSellerId: boolean;
  hasUserId: boolean;
  isCheckout?: boolean | null;
  isLoggedOutUser: boolean;
  isSeller?: boolean | null;
  itemId: string;
  orderId?: string | null;
  searchQuery?: string | null;
  sellerId: string;
  topicKey: string;
  transactionId: string;
  userCountryCode?: string | null;
  userId: string;
};
export type GetHelpZendeskModalRendererQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticle_viewer" | "GetHelpZendeskArticlesNoSearchResults_viewer" | "GetHelpZendeskArticlesSearchResults_viewer" | "GetHelpZendeskCmsTopic_viewer" | "GetHelpZendeskCommonQuestions_viewer" | "GetHelpZendeskContactSupportSearch_viewer" | "GetHelpZendeskContactSupport_viewer" | "GetHelpZendeskFooter_viewer" | "GetHelpZendeskModalCategory_viewer" | "GetHelpZendeskModalHeader_viewer" | "GetHelpZendeskModalIntro_viewer" | "GetHelpZendeskOrderInfo_viewer" | "GetHelpZendeskSellerItem_viewer" | "GetHelpZendeskSellerOrder_viewer">;
  };
};
export type GetHelpZendeskModalRendererQuery = {
  response: GetHelpZendeskModalRendererQuery$data;
  variables: GetHelpZendeskModalRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articleId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactSupportSearchQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasArticleId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasContactSupportSearchQuery"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasItemId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasOrderId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSearchQuery"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSellerId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCheckout"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLoggedOutUser"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSeller"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sellerId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicKey"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transactionId"
},
v19 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupKey",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "getHelpCmsTopicGroupTopic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topicLabel",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "kind": "Variable",
  "name": "isSeller",
  "variableName": "isSeller"
},
v24 = {
  "kind": "Variable",
  "name": "sellerId",
  "variableName": "sellerId"
},
v25 = [
  (v23/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v29 = [
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/)
],
v30 = [
  {
    "kind": "Variable",
    "name": "articleId",
    "variableName": "articleId"
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instructionalText",
  "storageKey": null
},
v35 = [
  (v33/*: any*/),
  (v34/*: any*/)
],
v36 = {
  "kind": "Variable",
  "name": "orderId",
  "variableName": "orderId"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sfChatToken",
  "storageKey": null
},
v39 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "touchpoint",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLiveAgentAvailable",
    "storageKey": null
  }
],
v40 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayValue",
    "storageKey": null
  }
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Period",
  "kind": "LinkedField",
  "name": "handlingTime",
  "plural": false,
  "selections": (v40/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Period",
  "kind": "LinkedField",
  "name": "collectionTime",
  "plural": false,
  "selections": (v40/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentServiceMethod",
  "kind": "LinkedField",
  "name": "serviceMethod",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "describeRange",
      "storageKey": null
    },
    (v28/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  (v43/*: any*/),
  (v41/*: any*/),
  (v28/*: any*/)
],
v45 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v46 = [
  (v33/*: any*/)
],
v47 = [
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  }
],
v48 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskModalRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskModalIntro_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskOrderInfo_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskArticle_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskModalHeader_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskArticlesSearchResults_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskContactSupport_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskFooter_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskModalCategory_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskCommonQuestions_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskCmsTopic_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskContactSupportSearch_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskArticlesNoSearchResults_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskSellerItem_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskSellerOrder_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v14/*: any*/),
      (v20/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v17/*: any*/),
      (v19/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetHelpZendeskModalRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "getHelpCmsTopicGroup",
            "kind": "LinkedField",
            "name": "getHelpCmsTopics",
            "plural": true,
            "selections": [
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupLabel",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "Contact1stdibsZendeskArticles",
            "kind": "LinkedField",
            "name": "zendeskArticles",
            "plural": false,
            "selections": [
              {
                "alias": "articlesSearch",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "query",
                    "value": ""
                  }
                ],
                "concreteType": "ZendeskArticle",
                "kind": "LinkedField",
                "name": "articles",
                "plural": true,
                "selections": (v29/*: any*/),
                "storageKey": "articles(query:\"\")"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isCheckout",
                    "variableName": "isCheckout"
                  }
                ],
                "concreteType": "ZendeskArticle",
                "kind": "LinkedField",
                "name": "promotedArticles",
                "plural": true,
                "selections": (v29/*: any*/),
                "storageKey": null
              },
              {
                "condition": "hasArticleId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v30/*: any*/),
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "article",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "hasSearchQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "query",
                        "variableName": "searchQuery"
                      }
                    ],
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "snippet",
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": (v30/*: any*/),
                "kind": "ScalarField",
                "name": "topicKeyForArticle",
                "storageKey": null
              },
              {
                "condition": "hasContactSupportSearchQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "supportArticlesSearch",
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "query",
                        "variableName": "contactSupportSearchQuery"
                      }
                    ],
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "Contact1stdibsZendeskSupport",
            "kind": "LinkedField",
            "name": "zendeskSupport",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZendeskSupportCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v31/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "categoryId",
                    "variableName": "categoryId"
                  }
                ],
                "concreteType": "ZendeskSupportCategorySections",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v23/*: any*/)
                    ],
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LeadTime",
            "kind": "LinkedField",
            "name": "leadTimes",
            "plural": true,
            "selections": [
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endTimeUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startTimeUnit",
                "storageKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "trackOrderGetHelpTopic",
            "args": [
              {
                "kind": "Literal",
                "name": "topicKey",
                "value": "trackOrder"
              }
            ],
            "concreteType": "GetHelpTopic",
            "kind": "LinkedField",
            "name": "getHelpTopic",
            "plural": false,
            "selections": (v35/*: any*/),
            "storageKey": "getHelpTopic(topicKey:\"trackOrder\")"
          },
          {
            "alias": "confirmOrderGetHelpTopic",
            "args": [
              (v23/*: any*/),
              {
                "kind": "Literal",
                "name": "topicKey",
                "value": "confirmOrder"
              }
            ],
            "concreteType": "GetHelpTopic",
            "kind": "LinkedField",
            "name": "getHelpTopic",
            "plural": false,
            "selections": (v35/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v23/*: any*/),
              (v36/*: any*/),
              {
                "kind": "Variable",
                "name": "topicKey",
                "variableName": "topicKey"
              }
            ],
            "concreteType": "GetHelpTopic",
            "kind": "LinkedField",
            "name": "getHelpTopic",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GetHelpTopicTypePrimaryCta",
                "kind": "LinkedField",
                "name": "primaryCta",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportCenterLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showContactButton",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportRequestTypeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "getHelpSellerCmsTopics",
            "args": [
              (v23/*: any*/),
              (v36/*: any*/)
            ],
            "concreteType": "getHelpCmsTopicGroup",
            "kind": "LinkedField",
            "name": "getHelpCmsTopics",
            "plural": true,
            "selections": [
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v28/*: any*/),
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId"
                  }
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/),
                  (v26/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailToken",
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "loggedInBuyerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Buyer_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Buyer_Messaging\")"
              }
            ]
          },
          {
            "condition": "hasOrderId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "transactionId",
                    "variableName": "transactionId"
                  }
                ],
                "concreteType": "Transaction",
                "kind": "LinkedField",
                "name": "transaction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "sku",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAvailableNow",
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionLeadTime",
                    "kind": "LinkedField",
                    "name": "leadTime",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasLeadTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "kind": "LinkedField",
                    "name": "shipment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deliveryDateRangeDisplay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimatedShippingDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTimeMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTimeMax",
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentTracking",
                        "kind": "LinkedField",
                        "name": "shipmentTracking",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "trackingNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "trackingUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Carrier",
                            "kind": "LinkedField",
                            "name": "carrier",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CarrierMetaData",
                                "kind": "LinkedField",
                                "name": "carrierMetaData",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "websiteUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerServiceEmail",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerServicePhoneNumber1",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerServicePhoneNumber2",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "internallyIntegrated",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lateByDate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isBuyerShipping",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionShipmentChangeReview",
                    "kind": "LinkedField",
                    "name": "pendingShipmentChangeReview",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Shipment",
                        "kind": "LinkedField",
                        "name": "shipment",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shipmentType",
                            "storageKey": null
                          },
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "kind": "LinkedField",
                        "name": "shipmentQuote",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "kind": "LinkedField",
                    "name": "currentShipmentQuote",
                    "plural": false,
                    "selections": (v44/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCanceled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionBuyerTimelineStatuses",
                    "kind": "LinkedField",
                    "name": "buyerTimelineStatuses",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shipped",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "completed",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v45/*: any*/),
                      (v28/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionCurrentBuyerTimelineStatus",
                    "kind": "LinkedField",
                    "name": "currentBuyerTimelineStatus",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionCurrentSellerTimelineStatus",
                    "kind": "LinkedField",
                    "name": "currentSellerTimelineStatus",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReturnPolicy",
                    "kind": "LinkedField",
                    "name": "returnPolicy",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReturnPolicyCopy",
                        "kind": "LinkedField",
                        "name": "buyerCopy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v47/*: any*/),
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsReturnCopy",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsDisclaimer",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v47/*: any*/),
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsShippingResponsibility",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsAdditionalNotesHeader",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "returnsFeesHeader",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v47/*: any*/),
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsRestockingFee",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsReturnPolicyMainHeader",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "detailsAttribution",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "customizableDetailReturnCopy",
                            "plural": false,
                            "selections": (v48/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "additionalNotes",
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Conversation",
                    "kind": "LinkedField",
                    "name": "conversation",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "buyer",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      {
                        "alias": "mcRedactionOpopAbTest",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "testName",
                            "value": "MC_removeRedactionOPOP_Mar2026"
                          }
                        ],
                        "concreteType": "AbTestConfigV2UserVariant",
                        "kind": "LinkedField",
                        "name": "abTestV2",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "variant",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "abTestV2(testName:\"MC_removeRedactionOPOP_Mar2026\")"
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isLoggedOutUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "loggedOutBuyerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Guest_Buyer_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Guest_Buyer_Messaging\")"
              }
            ]
          },
          {
            "condition": "hasSellerId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sellerSupportChat",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "touchpoint",
                    "value": "Seller_Messaging"
                  }
                ],
                "concreteType": "SupportChatQuery",
                "kind": "LinkedField",
                "name": "supportChat",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": "supportChat(touchpoint:\"Seller_Messaging\")"
              },
              {
                "alias": null,
                "args": [
                  (v24/*: any*/)
                ],
                "concreteType": "Seller",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "hasItemId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId"
                  }
                ],
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dealerReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dibsReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dealerStatusDisplay",
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskModalRendererQuery",
    "metadata": {},
    "name": "GetHelpZendeskModalRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d50c54dfc14490757e5c10bda2d541ca";

export default node;
